import { useState } from "react";
import { ShieldCheck, AlertTriangle } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { useLang } from "@/contexts/LangContext";
import { LangToggle } from "@/components/LangToggle";

const STORAGE_KEY = "oss-age-confirmed";

const initialOpen = () => {
  if (typeof window === "undefined") return false;
  return !window.sessionStorage.getItem(STORAGE_KEY);
};

export const AgeGate = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(initialOpen);
  const [declined, setDeclined] = useState(false);

  const confirm = () => {
    window.sessionStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid={HOME.ageGate}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-md p-6"
      role="dialog"
      aria-modal="true"
    >
      <div className="relative w-full max-w-md rounded-3xl border border-[#00ff41]/25 bg-[#0a0a0a]/95 p-8 shadow-[0_0_60px_rgba(0,255,65,0.18)]">
        <div className="flex items-center justify-between gap-3 mb-5">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#00ff41]/15 text-[#00ff41]">
              <ShieldCheck size={20} />
            </span>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#00ff41]">
              {t("age_ribbon")}
            </span>
          </div>
          <LangToggle />
        </div>

        <h2 className="font-display text-3xl sm:text-4xl font-extrabold leading-tight">
          {t("age_title_q")} <span className="text-[#00ff41]">{t("age_title_age")}</span>
          {t("age_title_end")}
        </h2>
        <p className="mt-3 text-sm sm:text-base text-neutral-300 leading-relaxed">{t("age_body")}</p>

        {declined ? (
          <div className="mt-5 flex items-start gap-2 rounded-xl border border-red-500/30 bg-red-500/10 p-3 text-sm text-red-200">
            <AlertTriangle size={16} className="mt-0.5 shrink-0" />
            <p>{t("age_denied")}</p>
          </div>
        ) : null}

        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          <button
            data-testid={HOME.ageGateConfirm}
            onClick={confirm}
            className="flex-1 rounded-full bg-[#00ff41] px-6 py-3 font-display font-bold text-black hover:bg-[#00e63a] transition-colors"
          >
            {t("age_yes")}
          </button>
          <button
            data-testid={HOME.ageGateDecline}
            onClick={() => setDeclined(true)}
            className="flex-1 rounded-full border border-white/20 px-6 py-3 font-display font-bold text-white hover:bg-white/5 transition-colors"
          >
            {t("age_no")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
